import React from 'react';
import ServiceTemplate from './ServiceTemplate';
import SEOMetaTags from '../../components/SEO/SEOMetaTags';
import { useTranslation } from '../../hooks/useTranslation';

import technologyMedtech from '../../assets/images/tech/technology-medtech.png';
import mateuszRecognition from '../../assets/images/team/Mateusz-recognition.png';

const MedtechPage: React.FC = () => {
    const { t, tJsx } = useTranslation();

    const industryCards = [
        {
            text: t("medtech.industry.card1"),
        },
        {
            text: t("medtech.industry.card2"),
        },
        {
            text: t("medtech.industry.card3"),
        }
    ];

    const howWeWorkSteps = [
        {
            title: t("medtech.howWeWork.step1.title"),
            description: [
                t("medtech.howWeWork.step1.description1"),
                t("medtech.howWeWork.step1.description2")
            ],
        },
        {
            title: t("medtech.howWeWork.step2.title"),
            description: [
                t("medtech.howWeWork.step2.description1"),
                t("medtech.howWeWork.step2.description2")
            ],
        },
        {
            title: t("medtech.howWeWork.step3.title"),
            description: [
                t("medtech.howWeWork.step3.description1"),
                t("medtech.howWeWork.step3.description2")
            ],
        },
        {
            title: t("medtech.howWeWork.step4.title"),
            description: [
                t("medtech.howWeWork.step4.description1"),
                t("medtech.howWeWork.step4.description2")
            ],
        }
    ];

    const nextSteps = [
        {
            title: t("medtech.nextSteps.step1")
        },
        {
            title: t("medtech.nextSteps.step2")
        },
        {
            title: t("medtech.nextSteps.step3")
        }
    ];

    const technologies = [
        { name: "technologyMedtech", logo: technologyMedtech },
    ];

    return (
        <>
            <SEOMetaTags
                title={{
                    pl: "Appotype: Oprogramowanie Medtech | Aplikacje Medyczne i Certyfikacja MDR",
                    en: "Appotype: Custom Software Development | IT Solutions for Business"
                }}
                description={{
                    pl: "Appotype: Tworzymy oprogramowanie Medtech i aplikacje medyczne zgodne z normami ISO, MDR, FDA. Pomagamy wdrożyć produkt i przejść certyfikację wyrobów medycznych. Twój partner technologiczny.",
                    en: "Appotype - We create custom software (web, mobile, AI) and provide comprehensive IT solutions for your business. Consulting, integration, outsourcing. Ask for a free consultation!"
                }}
                canonicalUrl="/uslugi/medtech"
            />
            <ServiceTemplate
                heroTitle={t("medtech.hero.title")}
                heroSubtitle={t("medtech.hero.subtitle")}
                industryTitle={t("medtech.industry.title")}
                industryCards={industryCards}
                howWeWorkTitle={t("medtech.howWeWork.title")}
                howWeWorkSteps={howWeWorkSteps}
                nextSteps={nextSteps}
                technologiesTitle={t("medtech.technologies.title")}
                technologies={technologies}
                recognition={{
                    title: t("medtech.recognition.title"),
                    subtitle: [
                        t("medtech.recognition.subtitle1"),
                        t("medtech.recognition.subtitle2")
                    ],
                    recognitionImage: mateuszRecognition,
                }}
                caseStudyTitle={t("medtech.caseStudy.title")}
            />
        </>
    );
};

export default MedtechPage; 